import React, { Fragment } from "react";
import { withRouter, Link } from "react-router-dom";

import BusquedaVoto from "../../components/components/busquedaVoto";

const AdminVoto = (props) => {
  const municipio = props.municipio;

  if (municipio === undefined || municipio?.etapa !== "votacion") return null;

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12">
          <h4 className="ppr-titulo centrado my-2">Administrar Voto</h4>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 centrar-col">
          <p>
            Haga click en el botón <b>"Añadir Voto"</b> para cargar un voto,
            recuerde controlar el DNI del vecino con el fin de corroborar que el
            mismo se encuentra habilitado para votar.
          </p>
          <p>
            En caso de error, el voto puede ser anulado buscando el mismo por
            DNI del vecino en la barra de búsqueda y luego se debe volver a
            ingresar.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mx-auto">
          <BusquedaVoto municipio={municipio} />
          <center>
            <Link
              to={"/consola/formvotacion"}
              className="btn ppr-btn-azul font-weight-bold m-2 mr-5"
            >
              Añadir Voto
            </Link>
          </center>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(AdminVoto);
